<template>
  <transition name="post">
    <article v-if="allReady" class="post">
      <header class="post__header">
        <h2 class="post__title">{{ title }}</h2>

        <h3 class="post__meta">
          Made by
          <router-link class="post__author" :to="`/by/${kebabify(author)}`">{{ author }}</router-link>
          <span class="post__sep"></span>
          <time v-if="!sold">
            <a :href="'https://ebay.com/itm/' + buy" class="buy">Buy It Now</a>
          </time>

          <time v-else>
            <span class="s">SOLD OUT</span>
          </time>
        </h3>

        <blockquote class="post__subtitle">{{ description }}</blockquote>
      </header>

      <section class="post__body rte" v-html="content"></section>

      <section v-if="manual">
        <div class="gviewer">
          <h2>User's Manual</h2>
          <iframe
            :src="'//docs.google.com/gview?url=' + manual + '&embedded=true'"
            width="100%"
            height="420"
            frameborder="0"
            class="viewer"
          ></iframe>
          <small
            style="display:block;color:#999;font-family:arial;font-size:60%;text-align:center;width:100%;margin:0 auto"
          >Can't load manual? Reload page</small>
        </div>
      </section>

      <section v-if="buy !== 'null'">
        <p>
          <br />
          <br />
          <small>
            <a
              style="font-size: smaller; float:right"
              :href="'https://ebay.com/itm/' + buy"
            >eBay Permalink</a>
          </small>
        </p>
      </section>

      <footer class="post__footer"></footer>
    </article>
  </transition>
</template>

<script>
// import VueDisqus from "vue-disqus/VueDisqus";
import { kebabify, prettyDate } from "../helpers";

export default {
  name: "blog-post",
  resource: "BlogPost",
  // components: { VueDisqus },
  props: { post: String },

  data() {
    return {
      manual: "",
      title: "",
      author: "",
      content: "",
      manual: "",
      published: "",
      description: "",
      sold: false,
      buy: "",
      commentsReady: false,
      ready: false
    };
  },

  computed: {
    allReady() {
      return this.ready && this.post;
    }
  },

  watch: {
    post(to, from) {
      if (to === from || !this.post) return;

      this.commentsReady = false;
      this.$getResource("post", to)
        .then(this.showComments)
        .then(() => {
          this.ready = true;
        });
    }
  },

  methods: {
    kebabify,
    prettyDate,
    showComments() {
      // This is injected by prerender-spa-plugin on build time, we don't prerender disqus comments.
      // if (
      //   window.__PRERENDER_INJECTED &&
      //   window.__PRERENDER_INJECTED.prerendered
      // ) {
      //   return;
      // }
      // setTimeout(() => {
      //   this.commentsReady = true;
      // }, 1000);
    }
  },

  mounted() {
    if (!this.post) {
      this.ready = true;
      return;
    }

    this.$getResource("post", this.post)
      .then(this.showComments)
      .then(() => {
        this.ready = true;
      });
  }
};
</script>

<style scoped>
span.s {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/BlogPost.vue